import { navigationConfig } from 'app/fuse-configs/navigationConfig';
import { FranchiseFeatureType } from 'app/main/apps/franchises/type';
import { UserRolesType } from '../authRoles';
import { UserModelInDTO } from '../store/type';

export const getUserRole = (user: UserModelInDTO) => {
  if (
    user.acl &&
    [UserRolesType.LB_SALE, UserRolesType.LB_TECH, UserRolesType.LB_DISTRIBUTOR].includes(user.acl.role)
  ) {
    return user.acl.role;
  }

  if (!user.hasFullAccess) {
    return UserRolesType.REGISTERED;
  }

  if (user.acl && user.isSubscribedRetailer) {
    return user.acl.role;
  }

  return undefined;
};

/**
 * Whether this sign-in has to go through the brand picker before landing anywhere.
 *
 * Lives here because there are two sign-in paths - `Auth.tsx` on a reload and
 * `loginSlice` on the form - and they have already drifted apart once.
 */
export const shouldPickBrand = (reachableCount: number, hasPickedBrand: boolean) =>
  reachableCount > 1 && !hasPickedBrand;

export const isFeatureAllowed = (feature: FranchiseFeatureType, franchiseFeatures?: FranchiseFeatureType[]) =>
  franchiseFeatures ? franchiseFeatures.includes(feature) : false;

export const getNavigationConfig = () => {
  return navigationConfig;
};
